import React from "react";
import {
  Link,
} from "react-router-dom";
import Alerts from '../components/Alerts'

const MiddleLayout = ({ children, alerts, bgImage, dark }) => {  
  return (
    <div
      className="flex-col md:flex-row justify-between flex gap-4 bg-no-repeat bg-contain md:bg-cover items-start bg-gray-500 h-screen"
      style={{backgroundImage: bgImage && `url(/assets/workshop.jpg)`}}
    >
      <div className='absolute w-full md:w-96 top-0 right-0 md:top-3'>
        {
          typeof alerts === "object" && <Alerts type={alerts.type} title={alerts.title} message={alerts.message}/>
        }
        {        
          Array.isArray(alerts) && alerts.map(({ title, message, type }) => <Alerts type={type} title={title} message={message}/>)
        }
      </div>
      <div className="mx-auto my-auto">
        <div className='w-full mb-5'>
          <Link to="/" className="text-white w-full justify-center flex items-center pl-8 space-x-2 px-4">
            <span className={`font-bold dark:text-white text-xl ${dark ? 'text-gray-100' : 'text-gray-800'}`}>Autolini</span>
          </Link>
        </div>
        {children}
        <div className="mt-12 text-center text-sm text-white">
          <a className="hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/cgv.pdf">
            Conditions Générales d'Utilisation et de Vente
          </a>
          <br/>
          <a className="hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/politique_de_Confidentialite.pdf">
            Politique de confidentialité
          </a>
        </div>
      </div>
    </div>
  );
}

export default MiddleLayout